<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 0.5H15.5V15.5H9.7656V12.7858C9.7656 11.4077 9.59957 10.2573 8.99095 9.4565C8.35336 8.61759 7.33184 8.28202 5.94333 8.28202H0.5V0.5Z" stroke="currentColor"/>
<path d="M9.59082 16C9.59082 13.2784 9.59082 14.8301 9.59082 12.665C9.59082 10.5 8.24961 8.52316 6.22573 8.52316L-0.291016 8.52316" stroke="currentColor" stroke-width="2"/>
</svg>
